import { render, staticRenderFns } from "./hqStuHealthQuestionEdit.vue?vue&type=template&id=a65edf34&scoped=true"
import script from "./hqStuHealthQuestionEdit.vue?vue&type=script&lang=js"
export * from "./hqStuHealthQuestionEdit.vue?vue&type=script&lang=js"
import style0 from "./hqStuHealthQuestionEdit.vue?vue&type=style&index=0&id=a65edf34&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a65edf34",
  null
  
)

export default component.exports